export const AMOUNTS = [
   [21, '👍'],
   [210, '👏'],
   [420, '⭐'],
   [555, '🔥'],
   [840, '🏅'],
   [1000, '🤙'],
   [5000, '💜'],
   [10000, '😻'],
   [20000, '🤩'],
   [50000, '🚀'],
   [100000, '🤯'],
   [1000000, '🏆'],
]

export const COMMENTS = [
   '👍 Amazing!',
   '🚀 LFG!',
   '⭐ Great job!',
   '👀 Looks good!',
   '🙏 Thank you!',
   '💜 Love it!',
   '👌 Way to go!',
   '😻 Yes please!',
   '🏆 Winner!',
   '💥 BOOM!',
   '🤣 LMAOF!',
   '🤯 OMFG!',
]

export const ZAP_STATUS = {
   INVOICE: 'invoice',
   PAYING: 'paying',
   DONE: 'done',
   ERROR: 'error',
   WAITING: 'waiting',
}
